import { $ } from 'hanako-ts/dist-legacy/Framework';
export class Ordering {
    constructor(container, callback) {
        this.container = container;
        this.items = this.container.children();
        this.callback = callback;
        this.items.forEach((item) => {
            item.draggable = true;
            item.addEventListener('dragstart', this.dragStart.bind(this));
            item.addEventListener('dragover', this.dragOver.bind(this));
            item.addEventListener('dragend', this.dragEnd.bind(this));
        });
    }
    dragStart(event) {
        this.draggedItem = $(event.currentTarget);
        this.draggedItem.addClass('dragged');
    }
    dragOver(event) {
        event.preventDefault();
        const target = $(event.currentTarget);
        const targetCenter = target.position().x + target.width() / 2;
        const draggedCenter = this.draggedItem.position().x + this.draggedItem.width() / 2;
        if (targetCenter > draggedCenter) {
            target.after(this.draggedItem);
        }
        else {
            target.before(this.draggedItem);
        }
    }
    dragEnd(event) {
        event.preventDefault();
        this.draggedItem.removeClass('dragged');
        this.callback();
    }
}
